import styled from 'styled-components/macro';
import { ThemeProps } from 'types/styled';

export const ScrollToTopBar = styled.div<ThemeProps<'div'>>`
  z-index: 1;
  width: 70px;
  height: 65px;

  display: flex;
  align-items: center;
  flex-direction: column;

  opacity: ${(props): number => (props.isTop ? 0 : 1)};
  transition: opacity 0.5s ease;

  position: ${(props): string => (props.isBottom ? 'absolute' : 'fixed')};
  bottom: ${({ isBottom, bottomMargin }): string =>
    isBottom ? `${bottomMargin === '32px' ? '236px' : '220px'}` : '30px'};
  right: 64px;

  &::after {
    cursor: pointer;
    content: 'Back to Top';
    font-family: Proxima Nova;
    font-size: 13px;
    color: #001247;
  }

  @media only screen and (max-width: 1439px) {
    bottom: ${({ isBottom, bottomMargin }): string =>
      isBottom ? `${bottomMargin === '32px' ? '236px' : '220px'}` : '30px'};
  }
  @media only screen and (max-width: 65em) {
    right: 32px;
  }
  @media only screen and (max-width: 50em) {
    right: 16px;
  }
  @media screen and (max-width: 52em) {
    &::after {
      display: none;
    }
    position: fixed;
    bottom: 30px;
    opacity: ${(props): number => (props.isVisible && !props.isTop ? 1 : 0)};
  }
`;

export const IconWrapper = styled('div')`
  position: absolute;
  left: 28px;
  top: 13px;
  color: #001247;

  svg {
    display: block;
  }
`;

export const UpButton = styled.a<ThemeProps<'a'>>`
  height: 34px;
  width: 34px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  background: #ffffff;
  margin-bottom: 8px;

  p {
    margin-left: ${({ theme }): string => theme.spacing.small};
  }
`;
